/**
 * React contexts for the Molecule framework bindings.
 *
 * These contexts provide access to core molecule providers throughout
 * the React component tree.
 *
 * @module
 */
import { createContext } from 'react';
/**
 * Context for state management provider.
 */
export const StateContext = createContext(null);
StateContext.displayName = 'MoleculeStateContext';
/**
 * Context for authentication client.
 */
export const AuthContext = createContext(null);
AuthContext.displayName = 'MoleculeAuthContext';
/**
 * Context for theme provider.
 */
export const ThemeContext = createContext(null);
ThemeContext.displayName = 'MoleculeThemeContext';
/**
 * Context for router.
 */
export const RouterContext = createContext(null);
RouterContext.displayName = 'MoleculeRouterContext';
/**
 * Context for internationalization provider.
 */
export const I18nContext = createContext(null);
I18nContext.displayName = 'MoleculeI18nContext';
/**
 * Context for HTTP client.
 */
export const HttpContext = createContext(null);
HttpContext.displayName = 'MoleculeHttpContext';
/**
 * Context for storage provider.
 */
export const StorageContext = createContext(null);
StorageContext.displayName = 'MoleculeStorageContext';
/**
 * Context for logger provider.
 */
export const LoggerContext = createContext(null);
LoggerContext.displayName = 'MoleculeLoggerContext';
/**
 * Context for AI chat provider.
 */
export const ChatContext = createContext(null);
ChatContext.displayName = 'MoleculeChatContext';
/**
 * Context for IDE workspace provider.
 */
export const WorkspaceContext = createContext(null);
WorkspaceContext.displayName = 'MoleculeWorkspaceContext';
/**
 * Context for code editor provider.
 */
export const EditorContext = createContext(null);
EditorContext.displayName = 'MoleculeEditorContext';
/**
 * Context for live preview provider.
 */
export const PreviewContext = createContext(null);
PreviewContext.displayName = 'MoleculePreviewContext';
//# sourceMappingURL=contexts.js.map